import { useTranslation } from "react-i18next";
import { darkAndLightThemeDefault } from "./ThemeComponents";
import { useContext, useEffect, useState } from "react";
import { ContentContext } from "../contexts/ContentContext";
import { NotificationContext } from "../contexts/NotificationContexts";
import { AccountContext } from "../contexts/AccountContexts";




export const ConfirmationModal = ({ isVisible, onClose, onConfirm, message }) => {
    const { t } = useTranslation('settings')
    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[10000]">
            <div className="bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 rounded-lg p-6 shadow-lg w-96">
                <h2 className="text-lg font-bold mb-4">{t('Confirm Action')}</h2>
                <p className="mb-6">{message}</p>
                <div className="flex justify-end space-x-4 gap-2">
                    <button
                        className={`btn ${darkAndLightThemeDefault}`}
                        onClick={() => onClose(false)}
                    >
                        {t('Cancel')}
                    </button>
                    <button
                        className="btn bg-primary hover:bg-sky-700 border-none text-white"
                        onClick={() => onConfirm(true)}
                    >
                        {t('Confirm')}
                    </button>
                </div>
            </div>
        </div>
    );
};


export const CopiedToClipboard = ({ }) => {
    const { t } = useTranslation('common')
    const { copied } = useContext(ContentContext)

    const [show, setShow] = useState(false)

    useEffect(() => {
        setShow(false)
        setTimeout(() => setShow(copied), 50)
    }, [copied])

    return (
        show &&
        <div id={`${copied}_copied`} className=" toast toast-top toast-center z-50">
            <div className="label py-3 px-5 rounded-lg bg-green-700 text-white border-green-700 sm:items-center sm:text-center sm:justify-center sm:content-center">
                <span className="w-full text-center">{t('Text copied!')}</span>
            </div>
            <div className="w-0"></div>
        </div>
    )
}


export const ConnectionLostMessage = ({ }) => {
    const { t } = useTranslation('errors')
    const { socket, reconnected, connectionLost } = useContext(NotificationContext)

    const [show, setShow] = useState(false)

    useEffect(() => {
        if (socket) {

            if (connectionLost) {
                setShow(true)
            }
            if (reconnected && !connectionLost) {
                setShow(false)
            }
        }
    }, [connectionLost, reconnected])

    return (
        show &&
        <div id={`${Date.now()}_copied`} className=" toast toast-top toast-center z-50">
            <div className="label py-3 px-5 rounded-lg bg-yellow-700 text-white border-yellow-700 sm:items-center sm:text-center sm:justify-center sm:content-center">
                <span className="w-full text-center">{t('connection_lost_reconnecting')}</span>
            </div>
            
            {/* <div className="label py-3 px-5 rounded-lg bg-success text-white sm:items-center sm:text-center sm:justify-center sm:content-cente">
                <small className="font-thin text-sm">Yenilikleri değişiklikler kısmından görebilirsiniz.</small>
            </div> */}
            <div className="w-0"></div>
        </div>
    )
}


export const DontShowAgainComponent = ({id, itemId, isSave}) => {

    const { user } = useContext(AccountContext)
    const { t } = useTranslation('settings')

    const itemId_ = `${user.id}_dontshowagain_${itemId}`

    const [dontShow, setDontShow] = useState(localStorage.getItem(itemId_) === "true")

    useEffect(() => {
        if (isSave) {
            localStorage.setItem(itemId_, dontShow)
        }
    }, [isSave])

    useEffect(() => {
        setDontShow(localStorage.getItem(itemId_) === "true")
    }, [id])

    return (
        <div className="flex items-center gap-2">
            <input type="checkbox" checked={dontShow} className="checkbox" onChange={(e) => setDontShow(e.target.checked)} />
            <span>{t("Don't show again.")}</span>
        </div>
    )
}


export function checkDontShowAgain(userId, id) {
    return localStorage.getItem(`${userId}_dontshowagain_${id}`) === "true"
}